export default __webpack_public_path__ + "static/media/_login-slide-adlibrary.00d519cc.png";